import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { failureFlagsMutationKeys } from 'queries/failure-flags/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

function unprotectFailureFlagApp([endpoint, params]: ReturnType<
  typeof failureFlagsMutationKeys.postAppsUnprotect
>) {
  return async () => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    await agent.post(endpointWithParams)
  }
}

export const usePostFailureFlagsAppsUnprotect = (
  appName: string,
  options?: Omit<MutationOptions, 'mutationKey' | 'mutationFn'>
) => {
  const { currentTeamId: teamId } = useAuth()

  const queryParams = {
    appName,
    teamId
  }

  const mutationKey = failureFlagsMutationKeys.postAppsUnprotect(queryParams)

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: unprotectFailureFlagApp(mutationKey)
  })
}
